<mat-form-field>
  <mat-select
    [disabled]="disabled()"
    [style]="getSelectedItemStyle()"
    [value]="order().orderSubState"
    [compareWith]="compareFn"
    (selectionChange)="setSelectedValue($event.value)">
    <!-- (selectionChange)="changed.emit($event.value)" -->
    @for (state of options(); track state) {
      <mat-option [value]="state" [style]="getItemStyle(state)">
        {{ state?.displayText }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
